import React, { Component, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as router from "react-router-dom";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import { logOut } from "../../containers/LoginContainer/actions";
import dashboardActions from "../DashboardContainer/action";
import { Link } from "react-router-dom";
import {
  AppAside,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav,
  AppNavbarBrand,
} from "@coreui/react";
import { navLicensee, navResidents } from "../../_nav";
// import SampleLogoSmall from "../../assets/img/logo-sh.png";NeoLogo
import SampleLogoSmall from "../../assets/img/NeoLogo1.svg";

import routes from "../../routes";
import DefaultFooter from "./DefaultFooter";

const DefaultAside = React.lazy(() => import("./DefaultAside"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader"));

class DefaultLayout extends Component {
  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  signOut(e, pusher) {
    e.preventDefault();
    this.props.cleardashboarddata();
    this.props.logoutaction();
    // this.props.history.push("/login");
  }

  componentDidMount = () => {};

  componentWillUnmount() {}

  render() {
    let fmsProfData = JSON.parse(localStorage.getItem("fmsProfDetail"));
    let baccess = localStorage.getItem("baccess");
    return (
      <div className="app">
        <AppSidebar fixed display="lg">
          <AppSidebarHeader>
            <Link to="/dashboard">
              <AppNavbarBrand
                full={{
                  src: SampleLogoSmall,
                  width: 200,
                  height: 50,
                  alt: "NeoWaterOn Logo",
                }}
              ></AppNavbarBrand>
            </Link>
          </AppSidebarHeader>
          <AppSidebarForm />
          <Suspense>
            {fmsProfData != null ? (
              <AppSidebarNav
                navConfig={
                  fmsProfData.status === "installation" && baccess != "yes"
                    ? navResidents
                    : navLicensee
                }
                {...this.props}
                router={router}
              />
            ) : (
              <Redirect from="/" to="/login" />
            )}
          </Suspense>
          <AppSidebarFooter />
        </AppSidebar>
        <AppHeader fixed>
          <Suspense fallback={this.loading()}>
            <DefaultHeader onLogout={(e) => this.signOut(e)} />
          </Suspense>
        </AppHeader>
        <div
          className="app-body"
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "80vh",
          }}
        >
          <main className="main">
            <AppBreadcrumb appRoutes={routes} router={router} />

            <Container fluid>
              <Suspense fallback={this.loading()}>
                <Switch>
                  {routes.map((route, idx) => {
                    return route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={(props) =>
                          localStorage.getItem("fmsToken") != null ? (
                            <route.component {...props} />
                          ) : (
                            <Redirect from="/" to="/login" />
                          )
                        }
                      />
                    ) : null;
                  })}
                  <Redirect from="/" to="/dashboard" />
                </Switch>
              </Suspense>
            </Container>
          </main>
          <DefaultFooter />
          <AppAside fixed>
            <Suspense fallback={this.loading()}>
              <DefaultAside />
            </Suspense>
          </AppAside>
        </div>
      </div>
    );
  }
}

const { cleardashboarddata } = dashboardActions;
function bindAction(dispatch) {
  return {
    logoutaction: () => {
      dispatch(logOut());
    },
    cleardashboarddata: () => {
      dispatch(cleardashboarddata());
    },
  };
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, bindAction)(DefaultLayout);
